const translation = {
  title: 'Explorer',
  sidebar: {
    discovery: 'Découverte',
    chat: 'Discussion',
    workspace: 'Espace de travail',
    action: {
      pin: 'Épingle',
      unpin: 'Détacher',
      rename: 'Renommer',
      delete: 'Supprimer',
    },
    delete: {
      title: 'Supprimer l\'application',
      content: 'Êtes-vous sûr de vouloir supprimer cette application ?',
    },
  },
  apps: {
    title: 'Explorez les applications par Dify',
    description: 'Utilisez ces applications modèles instantanément ou personnalisez vos propres applications basées sur les modèles.',
    allCategories: 'Recommandé',
  },
  appCard: {
    addToWorkspace: 'Ajouter à l\'espace de travail',
    customize: 'Personnaliser',
  },
  appCustomize: {
    title: 'Créer une application à partir de {{name}}',
    subTitle: 'Icône de l\'application & nom',
    nameRequired: 'Le nom de l\'application est requis',
  },
  category: {
    Assistant: 'Assistant',
    Writing: 'Écriture',
    Translate: 'Traduire',
    Programming: 'Programmation',
    HR: 'RH',
    Agent: 'Agent',
    Workflow: 'Flux de travail',
    Entertainment: 'Divertissement',
  },
}

export default translation
